import { UnStickResult } from '../models/sales/un-stick-result';

// The answer of POST SalesOrderLineAudit/UnStick (Sales Order What's Happened, D-8, D-15). Mirrors
// TMSWeb.Common.Constants.UnStickResults: always a 200 with a CODE, worded here (ui.md "Switch on an
// API refusal's code"). The two lists must stay in step.
export enum UnStickResults {
  // params: line (order/line), status (the demand status description now, as stored)
  unStuck = 'UnStuck',
  noLongerUnStickable = 'NoLongerUnStickable',
  // params: status (the demand status description, unchanged, as stored)
  notChanged = 'NotChanged',
}

/** "Line 101284/3 un-stuck: now Ready to Pick", or why nothing was done. */
export function unStickResultText(result: UnStickResult | undefined | null): string {
  switch (result?.code) {
    case UnStickResults.unStuck: {
      const line = result.parameters?.['line'] ?? '';
      const status = result.parameters?.['status'] ?? '';
      return $localize`Line ${line} un-stuck: now ${status}`;
    }
    case UnStickResults.noLongerUnStickable:
      return $localize`This line can no longer be un-stuck automatically`;
    case UnStickResults.notChanged: {
      const status = result.parameters?.['status'] ?? '';
      return $localize`Un-stick did not change this line. It is still ${status}:status:.`;
    }
    default:
      return result?.code ?? '';
  }
}
